import { UseCurrencyReturn } from '@/utils/hooks/useCurrency';
import { UseInstrumentReturn } from '@/utils/hooks/useInstrument';
import useLanguage from '@/utils/hooks/useLanguage';
import { RadioGroup } from '@headlessui/react';
import cn from 'classnames';
import { Fragment, useMemo } from 'react';

interface CurrencySwitchProps {
    value: string;
    instrument: UseInstrumentReturn;
    baseCurrency: UseCurrencyReturn;
    quoteCurrency: UseCurrencyReturn;
    disabled?: boolean;
    onChange: any;
    // onChange: (side: Side) => void;
}

export default function CurrencySwitch(props: CurrencySwitchProps) {
    const { instrument, baseCurrency, quoteCurrency, value, disabled, onChange } = props;
    const lang = useLanguage();

    const isCFD = useMemo(
        () => ['Index', 'Commodity', 'Future'].includes(instrument?.config?.type),
        [instrument.config]
    );

    return (
        <Fragment>
            {!isCFD && (
                <RadioGroup value={value} onChange={onChange} disabled={disabled}>
                    <div className="flex flex-row rounded-sm overflow-hidden text-xs uppercase">
                        <RadioGroup.Option
                            value={baseCurrency.celer}
                            className={cn('text-center focus:outline-none', { 'w-1/2': !disabled })}>
                            {({ checked }) => {
                                return (
                                    <div
                                        className={cn('px-3 py-1 cursor-pointer transition-colors border-2', {
                                            'border-brand-accent bg-brand-accent text-brand-module-title': checked,
                                            'border-brand-neutral-700 hover:border-brand-neutral-700 text-brand-text hover:text-brand-primary-light':
                                                !checked,
                                            'border-r-0 rounded-l-sm': !disabled && lang.dir === 'ltr',
                                            'border-l-0 rounded-r-sm': !disabled && lang.dir === 'rtl'
                                        })}>
                                        {baseCurrency.show}
                                    </div>
                                );
                            }}
                        </RadioGroup.Option>
                        <div className={cn('w-0.5 bg-brand-accent', { hidden: disabled })} />
                        <RadioGroup.Option value={quoteCurrency.celer} className="w-1/2 text-center focus:outline-none">
                            {({ checked }) => {
                                return (
                                    <div
                                        className={cn('px-3 py-1 transition-colors border-2 cursor-pointer', {
                                            'border-brand-accent bg-brand-accent text-brand-module-title': checked,
                                            'border-brand-neutral-700 hover:border-brand-neutral-700 text-brand-text hover:text-brand-primary-light':
                                                !checked && !disabled,
                                            hidden: disabled,
                                            'border-l-0 rounded-r-sm': lang.dir === 'ltr',
                                            'border-r-0 rounded-l-sm': lang.dir === 'rtl'
                                        })}>
                                        {quoteCurrency.show}
                                    </div>
                                );
                            }}
                        </RadioGroup.Option>
                    </div>
                </RadioGroup>
            )}
        </Fragment>
    );
}
